module.exports = __webpack_public_path__ + "static/confeti_left-bbac9c8c2ac5fd4a9e10f290d3cd7820.svg";